import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      background: '#f0f2f5'
    }}>
      {/* Panel izquierdo marino */}
      <div style={{
        width: '45%',
        background: '#012E40',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px'
      }}>
        <img
          src="/logo-blanco.png"
          alt="Infra Design"
          style={{ width: '280px', marginBottom: '40px' }}
        />
        <h2 style={{
          color: '#87B749',
          fontSize: '22px',
          fontWeight: '600',
          textAlign: 'center',
          marginBottom: '12px'
        }}>
          Sistema de Gestión
        </h2>
       <div style={{ marginTop: '8px', width: '100%', maxWidth: '280px' }}>
  {[
    { icon: '🏢', label: 'Gestión de Proveedores' },
    { icon: '📋', label: 'Gestión de Ofertas' },
    { icon: '👥', label: 'Gestión de Clientes' },
    { icon: '📊', label: 'Gestión Administrativa' },
  ].map((item, i) => (
    <div key={i} style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '10px 16px',
      marginBottom: '8px',
      background: 'rgba(255,255,255,0.07)',
      borderRadius: '8px',
      borderLeft: '3px solid #87B749'
    }}>
      <span style={{ fontSize: '16px' }}>{item.icon}</span>
      <span style={{
        color: 'rgba(255,255,255,0.85)',
        fontSize: '13px',
        fontWeight: '500'
      }}>{item.label}</span>
    </div>
  ))}
</div>
      </div>

      {/* Panel derecho login */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: '48px 40px',
          width: '100%',
          maxWidth: '380px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
        }}>
          <img
            src="/logo-small.png"
            alt="Infra Design"
            style={{ width: '140px', marginBottom: '32px' }}
          />
          <h3 style={{
            color: '#012E40',
            fontSize: '24px',
            fontWeight: '700',
            marginBottom: '8px'
          }}>
            Bienvenido
          </h3>
          <p style={{
            color: '#888',
            fontSize: '14px',
            marginBottom: '36px'
          }}>
            Ingresa con tu cuenta corporativa de Infra Design
          </p>
          <button
            onClick={handleLogin}
            style={{
              width: '100%',
              padding: '14px',
              background: '#012E40',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              fontSize: '15px',
              fontWeight: '500',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              transition: 'background 0.2s'
            }}
            onMouseOver={e => e.target.style.background = '#87B749'}
            onMouseOut={e => e.target.style.background = '#012E40'}
          >
            <svg width="20" height="20" viewBox="0 0 20 20">
              <rect x="1" y="1" width="8.5" height="8.5" fill="#F25022"/>
              <rect x="10.5" y="1" width="8.5" height="8.5" fill="#7FBA00"/>
              <rect x="1" y="10.5" width="8.5" height="8.5" fill="#00A4EF"/>
              <rect x="10.5" y="10.5" width="8.5" height="8.5" fill="#FFB900"/>
            </svg>
            Iniciar sesión con Microsoft
          </button>
          <p style={{
            color: '#ccc',
            fontSize: '11px',
            textAlign: 'center',
            marginTop: '24px'
          }}>
            Solo usuarios autorizados · Infra Design CR
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
